import { render } from "./RuiArrowDown.vue?vue&type=template&id=5367a85a"
const script = {}
script.render = render

export default script